function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(.633 16)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.326 16V0H17.84v16c-.58 0-1.05.48-1.05 1.068v1.068a1.06 1.06 0 0 0 1.05 1.067h10.492c.58 0 1.05-.479 1.05-1.067v-1.068A1.062 1.062 0 0 0 28.327 16z",
  fill: "#0F1941"
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#2175D9",
  cx: 23.086,
  cy: 26.667,
  rx: 5.246,
  ry: 5.333
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.116 21.333h-8.392c-.58 0-1.05.48-1.05 1.068v8.531A1.06 1.06 0 0 0 36.724 32h8.392c.579 0 1.05-.48 1.05-1.068v-8.537c0-.588-.471-1.062-1.05-1.062z",
  fill: "#FFB511",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#2175D9",
  cx: 5.246,
  cy: 26.667,
  rx: 5.246,
  ry: 5.333
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.95 21.333h-8.392c-.58 0-1.05.48-1.05 1.068v8.531A1.06 1.06 0 0 0 54.557 32h8.392c.579 0 1.05-.48 1.05-1.068v-8.537c0-.588-.471-1.062-1.05-1.062z",
  fill: "#FFB511",
  fillRule: "nonzero"
}));
function SvgTypeProductionCustomer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeProductionCustomer);
export default __webpack_public_path__ + "static/media/TypeProductionCustomer.002bea8f315841146493b24668f2c189.svg";
export { ForwardRef as ReactComponent };